import React from 'react';

const PasswordStrengthInstruction = ({passwordStrength, customClassName}) => {
    const getInstruction = () => {
        switch(Number(passwordStrength)){
            case 1:
                return (<React.Fragment>
                            <div>Password must include 5 characters including</div>
                            <ul>
                                <li>1 or more Uppercase Letters [A-Z]</li>
                                <li>1 or more Lowercase Letters [a-z]</li>
                                <li>1 or more Digits [0-9]</li>
                            </ul>
                        </React.Fragment>);
            case 2:
                return (<React.Fragment>
                            <div>Password must include 8 characters including</div>
                            <ul>
                                <li>1 or more Uppercase Letters [A-Z]</li>
                                <li>1 or more Lowercase Letters [a-z]</li>
                                <li>1 or more Digits [0-9]</li>
                            </ul>
                        </React.Fragment>);
            case 3:
                return (<React.Fragment>
                            <div>Password must include 8 characters including</div>
                            <ul>
                                <li>1 or more Uppercase Letters [A-Z]</li>
                                <li>1 or more Lowercase Letters [a-z]</li>
                                <li>1 or more Digits [0-9]</li>
                                <li>1 or more Special Characters [!@#$%^&*]</li>
                            </ul>
                        </React.Fragment>);
            default:
                return (<React.Fragment />);
        }
    };
    return (<div className={customClassName || "color-primary"}>{getInstruction()}</div>);
};
export default PasswordStrengthInstruction;
